<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import contenidoUsuarios from "@/components/widgets/contenidoUsuarios";
/**
 * Starter component
 */
export default {
  page: {
    title: "Autos",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: { Layout, contenidoUsuarios },
  data() {
    return {
      title: "Usuarios",
      items: [
        {
          text: "Usuarios",
          href: "/",
        },
        {
          text: "General",
          active: true,
        },
      ],
    };
  },
};
</script>
<template>
  <Layout>
    <div class="mb-4">
      <img :src="require('@/assets/images/recnet-header.png')" alt="Sesiones de reconstrucción"
        class="img-fluid w-100 rounded shadow-sm"
        style="max-height: 260px; object-fit: cover; object-position: center;" />
    </div>
    <contenidoUsuarios />
  </Layout>
</template>
